import {Component} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

@Component({
  selector: 'app-jurisdiction',
  templateUrl: './jurisdiction.component.html',
  styleUrls: ['./jurisdiction.component.scss']
})
export class JurisdictionComponent {

  enableJurisdictionCheck: boolean = true;

  constructor(private environmentService: EnvironmentService) {
    this.enableJurisdictionCheck = this.environmentService.jurisdictionCheckEnabled;
  }
}
